export const satisfactionSurvey = {
	title: "Pesquisa de satisfação",
	periodData: {
		thirty: "Últimos 30 dias",
		sixty: "Últimos 60 dias",
		ninety: "Últimos 90 dias",
		rangeFormat: "{{sinceDay}} de {{sinceMonth}} à {{untilDay}} de {{untilMonth}}",
		period: "Período",
		custom: "Período personalizado",
		placeholder: "Selecione o período",
	},
	tabs: {
		results: "Resultados",
		shareSettings: "Configurações e compartilhamento",
		searchSettings: "Configurações de pesquisa",
		newPlaceAvailable: "Novo local disponível",
		smsReport: "Relatório de investimento",
	},
	formatQuestionType: {
		service: "Serviço / Atendimento",
		product: "Produto",
		mixes: "Variedade do cardápio",
		cleaness: "Limpeza",
		price: "Preço",
		music: "Música",
		nps: "NPS",
		paymentExperience: "Experiência de pagamento",
	},
	results: {
		columns: {
			birthDate: "Data de Nascimento",
			client: "Cliente",
			date: "Data",
			document: "Documento",
			averageTicket: "Ticket médio",
			phone: "Telefone",
			ratingDate: "Data da avaliação",
			comment: "Comentário",
		},
		fileTitle: "Histórico de avaliações por evento",
		filename: "avaliacoes-nps",
		customerAnswer_one: "{{totCustomers}} cliente respondeu a pesquisa de satisfação",
		customerAnswer_other:
			"{{totCustomers}} clientes responderam a pesquisa de satisfação",
		lastDays_one: "no último {{days}} dia",
		lastDays_other: "nos últimos {{days}} dias",
		filterPlaceholder: "Filtre por casa",
		searchClientPlaceholder: "Buscar por nome ou CPF",
		export: "Exportar para Excel",
		resultsEvent: "Resultado da pesquisa por evento",
		emptyStateTitle: "Local não habilitado",
		emptyStateDescription:
			"Esse local não está habilitado para receber respostas da pesquisa de satisfação. Entre em contato com o time da Zig para que você possa ativar esse serviço.",
		popover: {
			answer_one: "{{totalAnswers}} avaliação",
			answer_other: "{{totalAnswers}} avaliações",
			client_one: "{{count}} cliente",
			client_other: "{{count}} clientes",
			opinion_one: "{{count}} opinião",
			opinion_other: "{{count}} opiniões",
		},
		drawer: {
			title: "Detalhes da experiência",
			event: "Evento",
			date: "Data",
			consumedProducts: "Produtos consumidos",
			assessment: "Avaliação",
			stars_one: "{{value}} estrela",
			stars_other: "{{value}} estrelas",
			answerNps:
				"De 1 à 10, a chance desse cliente recomendar {{name}} para amigos e familiares é",
			client: "Cliente",
			cpf: "CPF",
			phone: "Telefone",
			birthDate: "Data de nascimento",
		},
	},
	shareSettings: {
		title: "Configurações de compartilhamento",
		content:
			"É muito importante que sejam definidos os meios de ativação do cliente para que você possa ter um feedback justo da sua organização.",
		qrCodeSection: {
			title: "QR Code na mesa / salão",
			description:
				"Clique no botão abaixo para baixar e imprimir o QR Code que levará o seu cliente ao link da pesquisa de satisfação.",
			downloadButton: "Baixar QR Code",
		},
		smsSection: {
			title: "SMS manual",
			description:
				"Copie o link abaixo e envie uma mensagem para a lista de clientes selecionada por você. Basta ir na seção de mensagens na área do cliente.",
			copyButton: "Copiar link de pesquisa",
			cancelUpdates: "Cancelar alterações",
			saveUpdates: "Salvar alterações",
			dailyLimit: {
				label: "Limite de SMS diário",
				tooltip: "O valor cobrado por SMS enviado, consta no seu contrato.",
				description: "Esse será o limite para envios automáticos do link.",
			},
		},
		modal: {
			qrCode: "Baixar QRCode",
			qrCodeDescription: "Clique aqui para abrir QRCode",
			link: "Copiar link",
			linkDescription: "Clique para copiar o link da pesquisa",
			downloadAllQRCode: "Baixar todos QRCodes",
			rowModal: {
				qrCode:
					'Não há nenhum local habilitado. Para baixar o QRCode dessa pesquisa, basta ativá-la na aba "Configurações de pesquisa"',
				link:
					'Não há nenhum local habilitado. Para gerar um link para pesquisa de satisfação, basta ativá-la na aba "Configurações de pesquisa"',
			},
		},
	},
	searchSettings: {
		emptyState: {
			title: "Nenhum local habilitado",
			description:
				"Não foi encontrado local habilitado para configurar a pesquisa de satisfação. Entre em contato com o time da Zig para que você possa ativar esse serviço.",
		},
		title: "Configurações de pesquisa",
		description:
			"Escolha quais são os parâmetros que você deseja que os seus clientes avaliem por casa.",
		cancelButton: "Cancelar alterações",
		saveButton: "Salvar alterações",
		new: "Novo",
		successNotification: "As configurações de pesquisa foram atualizadas",
		shouldSendSmsOnCheckout:
			"Enviar SMS de NPS automaticamente para todos os clientes após o checkout",
	},
	customModal: {
		successNotification: "Link da pesquisa copiado",
	},
	smsReport: {
		filterByPlace: "Filtre por local",
		filterByDate: "Data do Evento",
		columns: {
			date: "Data do Evento",
			smsSentCount: "Sms enviados",
			npsAnswersCount: "Respostas",
			conversion: "Taxa de conversão por SMS",
		},
		totalizers: {
			smsSents: "Sms enviados",
			npsFormAnswers: "Total de respostas",
			checkins: "Taxa de conversão total",
		},
	},
};
